import {Flex, Text} from '@indoqa/style-system'
import {IStyle} from 'fela'
import * as React from 'react'
import {useFela} from 'react-fela'
import {Link} from 'react-router-dom'
import {Theme} from '../../../app/theme'
import {ThemedIcon} from '../../../commons-shared/themed-icon/ThemedIcon'
import {ReactComponent as ChevronRightIcon} from '../../../commons/icons/chevron-right.svg'

export interface Breadcrumb {
  name: string
  linkTo?: string
  emphasize?: boolean
}

interface Props {
  breadcrumbs: Breadcrumb[]
}

const breadcrumbStyle = (pos: number, fontSize: number | string): IStyle => {
  return {
    display: pos === 0 ? 'inline' : 'none',
    whiteSpace: 'nowrap',
    fontSize,
    tablet: {
      display: 'inline',
    },
    '& > a': {
      textDecoration: 'none',
      color: 'inherit',
    },
  }
}

const renderBreadcrumb = (breadcrumb: Breadcrumb, id: number, emphasizeColor: string, fontSize: number | string) => {
  const {name, linkTo} = breadcrumb
  const content = linkTo ? <Link to={linkTo}>{name}</Link> : name
  return (
    <Text
      ellipsis={id !== 0}
      key={id}
      style={breadcrumbStyle(id, fontSize)}
      color={breadcrumb.emphasize ? emphasizeColor : undefined}
    >
      {content}
    </Text>
  )
}

const renderSeparator = (id: number, fontSize: number | string, iconSize: number) => (
  <Text key={`${id}_sep`} style={breadcrumbStyle(id, fontSize)}>
    <ThemedIcon size={iconSize} color="white">
      <ChevronRightIcon />
    </ThemedIcon>
  </Text>
)

export const ReaderBreadcrumbsPanel: React.FC<Props> = ({breadcrumbs}) => {
  const {theme} = useFela<Theme>()
  const emphasizeColor = theme.colors.textHighlightAlternative
  const {toolbarFontSize, toolbarIconSize} = theme.layout.reader
  if (breadcrumbs.length === 0) {
    return null
  }
  const panels = []
  panels.push(renderBreadcrumb(breadcrumbs[0], 0, emphasizeColor, toolbarFontSize))
  if (breadcrumbs.length > 1) {
    for (let i = 1; i < breadcrumbs.length; i++) {
      const breadcrumb = breadcrumbs[i]
      if (breadcrumb.name && breadcrumb.name.length > 0) {
        panels.push(renderSeparator(i, toolbarFontSize, toolbarIconSize))
        panels.push(renderBreadcrumb(breadcrumb, i, emphasizeColor, toolbarFontSize))
      }
    }
  }
  return (
    <Flex nowrap overflowHidden alignItems="baseline" style={{lineHeight: 1.2}}>
      {panels}
    </Flex>
  )
}
